var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.063,
    height: 12.054,
    viewBox: "0 0 12.063 12.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4396.28,500.794a2.661,2.661,0,0,0-3.765,0l-6.9,6.9a.336.336,0,0,0-.1.2l-.512,3.786a.345.345,0,0,0,.1.29.352.352,0,0,0,.245.1.279.279,0,0,0,.046,0l2.282-.308a.347.347,0,1,0-.092-.688l-1.831.247.358-2.641,2.781,2.779a.351.351,0,0,0,.245.1.34.34,0,0,0,.244-.1l6.9-6.9a2.655,2.655,0,0,0,0-3.763Zm-3.631.848,1.16,1.159-6.3,6.3-1.158-1.159Zm-3.513,9.078L4388,509.587l6.3-6.3,1.133,1.133Zm6.782-6.792-2.772-2.772a1.969,1.969,0,0,1,2.772,2.772Z",
    transform: "translate(-4384.999 -500.014)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.b84628fe.svg";
export { ForwardRef as ReactComponent };